import { render, staticRenderFns } from "./WalletCashia.vue?vue&type=template&id=65dc855d&scoped=true"
import script from "./WalletCashia.vue?vue&type=script&lang=js"
export * from "./WalletCashia.vue?vue&type=script&lang=js"
import style0 from "./WalletCashia.vue?vue&type=style&index=0&id=65dc855d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc855d",
  null
  
)

export default component.exports